import PropTypes from 'prop-types';
import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';

import { Vehicle } from '@sm360/widget-commons-vehicle';

import Certification from '../Certification/Certification.jsx';

const { BADGE_STATUS, VehicleModel, CertificationIconService: getCertificationIcon } = Vehicle;

const Badges = ({
    certifiedText,
    inspectedText,
    tradedText,
    warrantyText,
    warrantyBadge,
    certifiedBadge,
    inspectedBadge,
    tradedBadge,
    hasCarfaxBadge,
    vehicle,
}) => {
    if (!vehicle || !vehicle.flags) {
        return null;
    }

    const avaibleFlags = {
        asTraded: false,
        certified: false,
        warranty: false,
        inspected: false,
    };

    vehicle.flags.forEach(({ type }) => {
        avaibleFlags.asTraded = avaibleFlags.asTraded || type === BADGE_STATUS.AS_TRADED;
        avaibleFlags.certified = avaibleFlags.certified || type === BADGE_STATUS.CERTIFIED;
        avaibleFlags.warranty = avaibleFlags.warranty || type === BADGE_STATUS.EXTENDED_WARANTY;
        avaibleFlags.inspected = avaibleFlags.inspected || type === BADGE_STATUS.INSPECTED;
    });

    const certificationIcon = getCertificationIcon(vehicle.make);
    const hasCertifiedFlag = avaibleFlags.certified && certifiedText && certifiedText !== '';
    const certifiedTag =
        certificationIcon && !certifiedBadge ? (
            <img className="certification__image" alt={certifiedText} src={getCertificationIcon(vehicle.make)} />
        ) : (
            <Certification
                extraClasses="certified-no-icon"
                certificationText={certifiedText}
                certificationBadge={certifiedBadge}
            />
        );

    const hasTraded = avaibleFlags.asTraded &&
        tradedText &&
        tradedText !== '' && <Certification certificationText={tradedText} certificationBadge={tradedBadge} />;

    const hasWarranty = avaibleFlags.warranty &&
        warrantyText &&
        warrantyText !== '' && <Certification certificationText={warrantyText} certificationBadge={warrantyBadge} />;

    const isInspected = avaibleFlags.inspected &&
        inspectedText &&
        inspectedText !== '' && <Certification certificationText={inspectedText} certificationBadge={inspectedBadge} />;

    const hasCarfax = (
        <a
            className="carfax-icon"
            href={LocaleService.t('CARFAX.LINK', {
                make: vehicle.make,
                model: vehicle.model,
                year: vehicle.year,
                trim: vehicle.modelTrim,
                stock: vehicle.stockNumber,
                id: vehicle.vehicleId,
            })}
        >
            <img
                className="carfax-image"
                alt={LocaleService.t('CARFAX.TITLE')}
                src="//s3.amazonaws.com/fs-sm360/var/images/sm360/icone/carproof_badge.png"
            />
        </a>
    );

    const badgingSection = hasCarfaxBadge ? (
        <div className="certification-badge-carfax">
            {hasCertifiedFlag && certifiedTag}
            {(hasTraded || hasWarranty || isInspected) && (
                <div className="certification-badge-section">
                    {hasTraded}
                    {hasWarranty}
                    {isInspected}
                </div>
            )}
            {/*
            Is is important that the div below has the `carproof-badge` class
            even with the carproof buyout at the moment. Otherwise, the badges
            will not be displayed. You can verify the class name to use
            here:  https://badgingapi.carfax.ca/Scripts/CarProofBadges.js
            */}
            <div className="carproof-badge" data-vin={vehicle.vin} />
        </div>
    ) : (
        <div className="certification-badge">
            {hasCertifiedFlag && certifiedTag}
            {(hasCarfax || hasTraded || hasWarranty || isInspected) && (
                <div className="certification-badge-secondary">
                    {hasCarfax}
                    {hasTraded}
                    {hasWarranty}
                    {isInspected}
                </div>
            )}
        </div>
    );

    return <div className="vehicle-certification">{badgingSection}</div>;
};

Badges.propTypes = {
    certifiedText: PropTypes.string.isRequired,
    inspectedText: PropTypes.string.isRequired,
    tradedText: PropTypes.string.isRequired,
    warrantyText: PropTypes.string.isRequired,
    certifiedBadge: PropTypes.string.isRequired,
    inspectedBadge: PropTypes.string.isRequired,
    tradedBadge: PropTypes.string.isRequired,
    warrantyBadge: PropTypes.string.isRequired,
    hasCarfaxBadge: PropTypes.bool.isRequired,
    vehicle: PropTypes.instanceOf(VehicleModel).isRequired,
};

Badges.displayName = 'Tile.Badges';

export default Badges;



// WEBPACK FOOTER //
// /builds/development/frontend/widgets/widgets/components/tiles/tile-a/src/components/Tile/InventoryUsed/Badges/Badges.jsx